(function () {
  function initSizingHelp(root) {
    if (root.dataset.sizingInit === '1') return;
    root.dataset.sizingInit = '1';

    root.querySelectorAll('.sizing-help__tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var chart = tab.getAttribute('data-chart');
        root.querySelectorAll('.sizing-help__tab').forEach(function (btn) {
          btn.classList.toggle('is-active', btn === tab);
        });
        root.querySelectorAll('[data-chart-panel]').forEach(function (panel) {
          panel.classList.toggle('hide', panel.getAttribute('data-chart-panel') !== chart);
        });
      });
    });

    root.querySelectorAll('.sizing-help__unit').forEach(function (button) {
      button.addEventListener('click', function () {
        var unit = button.getAttribute('data-unit');
        root.querySelectorAll('.sizing-help__unit').forEach(function (btn) {
          var active = btn === button;
          btn.classList.toggle('is-active', active);
          btn.classList.toggle('active-unit', active);
          btn.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        root.classList.toggle('is-in', unit === 'in');
      });
    });
  }

  var bodyScrollLockY = 0;

  function resolveModal(wrapper) {
    var modal = wrapper.querySelector('[data-size-guide-modal]');
    if (!modal && wrapper.id) {
      modal = document.querySelector(
        '[data-size-guide-modal][data-guide-owner="' + wrapper.id + '"]'
      );
    }
    return modal;
  }

  function portalModalToBody(modal, wrapper) {
    if (!modal || !wrapper) return;
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
    modal.dataset.portaled = '1';
    modal.dataset.guideOwner = wrapper.id;
    modal.classList.add('size-guide__modal--portaled');
  }

  function lockBodyScroll() {
    bodyScrollLockY = window.scrollY || window.pageYOffset || 0;
    document.body.style.top = '-' + bodyScrollLockY + 'px';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.classList.add('size-guide-open');
  }

  function unlockBodyScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.classList.remove('size-guide-open');
    window.scrollTo(0, bodyScrollLockY);
  }

  function initSizeGuidePopup(wrapper) {
    if (wrapper.dataset.guideInit === '1') return;
    wrapper.dataset.guideInit = '1';

    var openBtn = wrapper.querySelector('[data-size-guide-open]');
    var modal = resolveModal(wrapper);
    var closeBtn = modal && modal.querySelector('[data-size-guide-close]');
    var sizingRoot = modal && modal.querySelector('.sizing-help');

    if (!openBtn || !modal || !closeBtn) return;

    portalModalToBody(modal, wrapper);
    if (sizingRoot) initSizingHelp(sizingRoot);

    function openModal() {
      portalModalToBody(modal, wrapper);
      modal.hidden = false;
      modal.classList.remove('is-closing');
      lockBodyScroll();
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          modal.classList.add('is-open');
        });
      });
      closeBtn.focus();
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.classList.add('is-closing');
      window.setTimeout(function () {
        modal.hidden = true;
        modal.classList.remove('is-closing');
        unlockBodyScroll();
        openBtn.focus();
      }, 280);
    }

    openBtn.addEventListener('click', openModal);
    closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal();
    });

    wrapper._closeModal = closeModal;
    modal._closeModal = closeModal;
  }

  function onKeyDown(event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-size-guide-modal]:not([hidden])').forEach(function (modal) {
      if (modal._closeModal) modal._closeModal();
    });
  }

  function boot() {
    document.querySelectorAll('.sizing-help').forEach(function (root) {
      if (!root.closest('.size-guide')) initSizingHelp(root);
    });
    document.querySelectorAll('.size-guide').forEach(initSizeGuidePopup);
    document.addEventListener('keydown', onKeyDown);
  }

  document.addEventListener('DOMContentLoaded', boot);

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('.sizing-help').forEach(function (root) {
      if (!root.closest('.size-guide')) initSizingHelp(root);
    });
    event.target.querySelectorAll('.size-guide').forEach(initSizeGuidePopup);
  });
})();
